import React from 'react';
import './App.css';
import EngineeringJournal from './components/EngineeringJournal';

function App() {
  return (
    <div className="app-root">
      <EngineeringJournal />
    </div>
  );
}

export default App;
